var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('main',{staticClass:"main",class:{ 'main--flush': _vm.isHome }},[_c('router-view'),_c('Connect')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }